export default class MegaMenu {

    constructor() {

        this.settings = {
            $dropdownTrigger : $('.js-menu-dropdown-trigger')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        if (this.settings.$dropdownTrigger.length > 0) {
            this.settings.$dropdownTrigger.on('click', (e) => {

                const $this = $(e.currentTarget);
                const $icon = $this.find('.js-toggle-icon');
                const $dropdownTarget = $this.find('.js-menu-dropdown-target');

                $('.js-menu-dropdown-target').not($dropdownTarget).addClass('hidden');
                $('.js-toggle-icon').not($icon).removeClass('rotate-180');

                $dropdownTarget.toggleClass('hidden');
                $icon.toggleClass('rotate-180');
            });
        }

    }

};

new MegaMenu();